/* unplugin-vue-components disabled */import script from "./NavigationProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./NavigationProgressBar.vue?vue&type=style&index=0&id=5f83f32b&scoped=true&lang=css"

import exportComponent from "../../../../deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f83f32b"]])

export default __exports__